import { ReturnReasonEnum } from '../../../core/enums/common/return_reason';

export const getReturnReasonOptions = [
    { value: ReturnReasonEnum.PRODUCT_THEFT.value, label: ReturnReasonEnum.PRODUCT_THEFT.label },
    { value: ReturnReasonEnum.DAMAGED_PRODUCT.value, label: ReturnReasonEnum.DAMAGED_PRODUCT.label },
    { value: ReturnReasonEnum.POOR_PRODUCT_QUALITY.value, label: ReturnReasonEnum.POOR_PRODUCT_QUALITY.label },
    { value: ReturnReasonEnum.OTHER.value, label: ReturnReasonEnum.OTHER.label },
];
